import React from 'react'
import Plus from '../icons/Plus'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { CREATE_SLIDE } from '../redux/manageSlidesReducer'

type Props = {}

const CreateSlideButton = (props: Props) => {
  const { lessonPlanId } = useParams()
  const dispatch = useDispatch()
  const handleCreateSlide = () => {
    if (!lessonPlanId) return
    dispatch(CREATE_SLIDE({ lessonPlanId }))
  }
  return (
    <div
      className="bg-slateGray px-4 py-2 rounded-md flex items-center gap-1 cursor-pointer"
      onClick={handleCreateSlide}>
      <div className="text-white w-5 h-5">
        <Plus />
      </div>
      <div className="text-14 font-semibold text-white">Add Slide</div>
    </div>
  )
}

export default CreateSlideButton
